export interface PollingObserver {
  observers: PollingUpdateAction[];
  subscribe: (action: PollingUpdateAction) => void;
  unsubscribe: (action: PollingUpdateAction) => void;
}

export type PollingUpdateAction = <T>(pollingEvent: T) => void;

export default class LongPollingService {
  private readonly pollingObserver: PollingObserver = {
    observers: [],
    subscribe: function(a) {
      this.observers.push(a);
    },
    unsubscribe: function(a) {
      this.observers = this.observers.filter(subscriber => subscriber !== a);
    },
  };

  constructor() {}

  public startListening<T>(apiMethod: () => Promise<T>): PollingObserver {
    const pollTime = 60000;
    setInterval(() => {
      apiMethod().then((res: T) => {
        this.pollingObserver.observers.forEach(observer => observer(res));
      });
    }, pollTime);

    return this.pollingObserver;
  }
}
